import { required,maxLength } from "vuelidate/lib/validators";
const mznmezunlar = {
  data() {
    return {
      mznmezunlarData: {
        Tckimlikno: null,
        Adisoyadi: null,
        Dogumyeri:null,
        Dogumtarihi: null,
        Cinsiyet:null,
        Uyruk:null,
        Yasadigiulke: null,
        Yasadigisehir: null,
        Konumlongitude: null,
        Konumlatitudes: null, 
        Medenidurum:null,
        Fotograf: null,  

        Saglikengeli:null,
        Saglikengelitipi:null,
        Ehliyet:null,
        Askerlik:null,
        Isaramadurumu:null,
        Calismadurumu:null,


        Eposta: null,
        Telefon: null,
        Evadresi:null,
        Website:null,
        Facebook: null,
        Instagram: null,
        Twitter: null,
        Linkedin: null,
        Isadresi: null,
        Istelefonu: null,
        Gerektigindeulasilacakkisi:null,

        Ozetbilgi:null,
        Kariyerhedefi:null,
        Egitimbilgileri:[],
        Isstajbilgileri:[],
        Kursbilgileri:[],
        Sertifikabilgileri:[],
        Sinavbilgisi:[],
        Yabancidilbilgisi:[],
        Bilgisayarbilgisi:[],
        Yayinbilgilerim:[],
        Odulbilgileri:[],
        Projebilgileri:[],
        Kulturelfaaliyetbilgileri:[],
        Dernekuyelikleri:[],
        Yetkinlikler:[],
        Referanslar:[], 
        Gizlilik: JSON.stringify({
          "Ozgecmis":2,
          "KisiselBilgiler":2,
          "TCKimlikNo":2,
          "Uyruk":2,
          "DurumBilgiler":2,
          "İletisimBilgiler":2,
          "OzetBilgi":2,
          "KariyerHedefi":2,
          "EgitimBilgiler":2,
          "IsStajBilgiler":2,
          "KursBilgiler":2,
          "SertifikaBilgiler":2,
          "SınavBilgiler":2,
          "YabanciDilBilgiler":2,
          "BilgisayarBilgiler":2,
          "YayinBilgiler":2,
          "OdulBilgiler":2,
          "ProjeBilgiler":2,
          "KulturelBilgiler":2
          })
      },

      FormDataType: {
        Tckimlikno: {
          FieldName: "Tckimlikno",
          Field: "input",
          FieldTitle: this.$t('mznmezunlar.AddEdit.KisiselBilgiler.Tckimlikno'),
          Disabled:"Disabled"
        },
        Adisoyadi: {
          FieldName: "Adisoyadi",
          Field: "input",
          FieldTitle: this.$t('mznmezunlar.AddEdit.KisiselBilgiler.Adisoyadi')
        },
        Dogumyeri: {
          FieldName: "Dogumyeri", 
          Field: "combobox", 
          FieldTitle: this.$t('mznmezunlar.AddEdit.KisiselBilgiler.Dogumyeri'), 
          ComboDataArray: []
        },
        Dogumtarihi: {
          FieldName: "Dogumtarihi",
          Field: "date",
          FieldTitle: this.$t('mznmezunlar.AddEdit.KisiselBilgiler.Dogumtarihi')
        },
        Yasadigiulke: {
          FieldName: "Yasadigiulke", 
          Field: "combobox", 
          FieldTitle: this.$t('mznmezunlar.AddEdit.KisiselBilgiler.Yasadigiulke'), 
          ComboDataArray: []
        },
        Yasadigisehir: {
          FieldName: "Yasadigisehir", 
          Field: "combobox", 
          FieldTitle: this.$t('mznmezunlar.AddEdit.KisiselBilgiler.Yasadigisehir'), 
          ComboDataArray: []
        },
        Konumlongitude: {
          FieldName: "Konumlongitude", 
          Field: "input", 
          FieldTitle: this.$t('mznmezunlar.AddEdit.Konumlongitude'),
          Disabled:"Disabled"
        },
        Konumlatitudes: {
          FieldName: "Konumlatitudes", 
          Field: "input", 
          FieldTitle: this.$t('mznmezunlar.AddEdit.Konumlatitudes'),
          Disabled:"Disabled"
        } ,
        Fotograf: {
          FieldName: "Fotograf", 
          Field: "input", 
          FieldTitle: this.$t('mznmezunlar.AddEdit.KisiselBilgiler.Fotograf')
        },
        Cinsiyet: {
          FieldName: "Cinsiyet", 
          Field: "combobox", 
          FieldTitle: this.$t('mznmezunlar.AddEdit.KisiselBilgiler.Cinsiyet'), 
          ComboDataArray: []
        },
        Uyruk: {
          FieldName: "Uyruk", 
          Field: "combobox", 
          FieldTitle: this.$t('mznmezunlar.AddEdit.KisiselBilgiler.Uyruk'), 
          ComboDataArray: []
        },
        Medenidurum: {
          FieldName: "Medenidurum", 
          Field: "combobox", 
          FieldTitle: this.$t('mznmezunlar.AddEdit.KisiselBilgiler.Medenidurum'), 
          ComboDataArray: []
        },

        
        Saglikengeli: {
          FieldName: "Saglikengeli", 
          Field: "combobox", 
          FieldTitle: this.$t('mznmezunlar.AddEdit.DurumBilgileri.Saglikengeli'), 
          ComboDataArray: []
        },
        Saglikengelitipi: {
          FieldName: "Saglikengelitipi", 
          Field: "combobox", 
          FieldTitle: this.$t('mznmezunlar.AddEdit.DurumBilgileri.Saglikengelitipi'), 
          ComboDataArray: []
        },
        Ehliyet: {
          FieldName: "Ehliyet", 
          Field: "combobox", 
          FieldTitle: this.$t('mznmezunlar.AddEdit.DurumBilgileri.Ehliyet'), 
          ComboDataArray: []
        },
        Askerlik: {
          FieldName: "Askerlik", 
          Field: "combobox", 
          FieldTitle: this.$t('mznmezunlar.AddEdit.DurumBilgileri.Askerlik'), 
          ComboDataArray: []
        },
        Isaramadurumu: {
          FieldName: "Isaramadurumu", 
          Field: "combobox", 
          FieldTitle: this.$t('mznmezunlar.AddEdit.DurumBilgileri.Isaramadurumu'), 
          ComboDataArray: []
        },
        Calismadurumu: {
          FieldName: "Calismadurumu", 
          Field: "combobox", 
          FieldTitle: this.$t('mznmezunlar.AddEdit.DurumBilgileri.Calismadurumu'), 
          ComboDataArray: []
        },


        
        Eposta: {
          FieldName: "Eposta", 
          Field: "input", 
          FieldTitle: this.$t('mznmezunlar.AddEdit.IletisimBilgileri.Eposta')
        },
        Telefon: {
          FieldName: "Telefon", 
          Field: "input", 
          FieldTitle: this.$t('mznmezunlar.AddEdit.IletisimBilgileri.Telefon')
        },
        Evadresi: {
          FieldName: "Evadresi", 
          Field: "input", 
          FieldTitle: this.$t('mznmezunlar.AddEdit.IletisimBilgileri.Evadresi')
        },
        Website: {
          FieldName: "Website", 
          Field: "input", 
          FieldTitle: this.$t('mznmezunlar.AddEdit.IletisimBilgileri.Website')
        },
        Facebook: {
          FieldName: "Facebook", 
          Field: "input", 
          FieldTitle: this.$t('mznmezunlar.AddEdit.IletisimBilgileri.Facebook')
        },
        Instagram: {
          FieldName: "Instagram", 
          Field: "input", 
          FieldTitle: this.$t('mznmezunlar.AddEdit.IletisimBilgileri.Instagram')
        },
        Twitter: {
          FieldName: "Twitter", 
          Field: "input", 
          FieldTitle: this.$t('mznmezunlar.AddEdit.IletisimBilgileri.Twitter')
        },
        Linkedin: {
          FieldName: "Linkedin", 
          Field: "input", 
          FieldTitle: this.$t('mznmezunlar.AddEdit.IletisimBilgileri.Linkedin')
        },
        Isadresi: {
          FieldName: "Isadresi", 
          Field: "input", 
          FieldTitle: this.$t('mznmezunlar.AddEdit.IletisimBilgileri.Isadresi')
        },
        Istelefonu: {
          FieldName: "Istelefonu", 
          Field: "input", 
          FieldTitle: this.$t('mznmezunlar.AddEdit.IletisimBilgileri.Istelefonu')
        },
        Gerektigindeulasilacakkisi: {
          FieldName: "Gerektigindeulasilacakkisi", 
          Field: "input", 
          FieldTitle: this.$t('mznmezunlar.AddEdit.IletisimBilgileri.Gerektigindeulasilacakkisi')
        },



        Ozetbilgi: {
          FieldName: "Ozetbilgi", 
          Field: "input", 
          FieldTitle: this.$t('mznmezunlar.AddEdit.Ozetbilgi.Ozetbilgi')
        },


        Kariyerhedefi: {
          FieldName: "Kariyerhedefi", 
          Field: "input", 
          FieldTitle: this.$t('mznmezunlar.AddEdit.Kariyerhedefi.Kariyerhedefi')
        } ,
        Gizlilik: {
          FieldName: "Gizlilik", 
          Field: "combobox", 
          FieldTitle: this.$t('mznmezunlar.AddEdit.Gizlilik'), 
          ComboDataArray: [{Id:0,Value:"Herkese Kapalı"},{Id:1,Value:"Arkadaş Listeme Açık"},{Id:2,Value:"Herkese Açık"}]
        },
      }
    }
  },
  validations: {
    FormData: {
      Tckimlikno: { required }, 
      Adisoyadi: { required },
      Dogumyeri:{},
      Dogumtarihi:{},
      Yasadigiulke:{},
      Yasadigisehir:{},
      Fotograf: {}, 
      Cinsiyet: {}, 
      Uyruk: {},  
      Medenidurum: {}, 
      Konumlongitude: {},
      Konumlatitudes: {}, 

      Saglikengeli:{},
      Saglikengelitipi:{},
      Ehliyet:{},
      Askerlik:{},
      Isaramadurumu:{required},
      Calismadurumu:{},

      Eposta: { required },
      Telefon: {required},
      Evadresi: {},
      Website: {},
      Facebook: {},
      Instagram: {},
      Twitter: {},
      Linkedin: {},
      Isadresi: {},
      Istelefonu: {},
      Gerektigindeulasilacakkisi: {},
 

      Ozetbilgi:{ maxLength: maxLength(500)},

      Kariyerhedefi:{ maxLength: maxLength(500)},

      Gizlilik:{},
        

      
    }

  },
  created() {
    let Page = {
      PageNumber: "1",
      PageSize: "9999",
    };
    this.ActionsGet({ Service: "ouyruk", Page: Page}).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        this.FormDataType.Yasadigiulke.ComboDataArray.push({
          id: res.Data[i].Id,
          label: res.Data[i].Uyrukadi,
        });
        this.FormDataType.Uyruk.ComboDataArray.push({
          id: res.Data[i].Id,
          label: res.Data[i].Uyrukadi,
        });
      }
    });

    this.ActionsFilterGet({ Service: "OIlIlce", Page: Page, Filter: "&Sadeceiller=true" }).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        this.FormDataType.Yasadigisehir.ComboDataArray.push({
          Id: res.Data[i].Id,
          Value: res.Data[i].Value,
        });
        this.FormDataType.Dogumyeri.ComboDataArray.push({
          Id: res.Data[i].Id,
          Value: res.Data[i].Value,
        });
      }
    });
    this.ActionsSabitGet(5).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        this.FormDataType.Askerlik.ComboDataArray.push({
          Id: res.Data[i].Id,
          Value: res.Data[i].Value,
        });
      }
    });
    this.ActionsSabitGet(11).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        this.FormDataType.Saglikengeli.ComboDataArray.push({
          Id: res.Data[i].Id,
          Value: res.Data[i].Value,
        });
      }
    });
    this.ActionsSabitGet(147).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        this.FormDataType.Saglikengelitipi.ComboDataArray.push({
          Id: res.Data[i].Id,
          Value: res.Data[i].Value,
        });
      }
    });
    this.ActionsSabitGet(11).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        this.FormDataType.Ehliyet.ComboDataArray.push({
          Id: res.Data[i].Id,
          Value: res.Data[i].Value,
        });
      }
    });
    this.ActionsSabitGet(2).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        this.FormDataType.Isaramadurumu.ComboDataArray.push({
          Id: res.Data[i].Id,
          Value: res.Data[i].Value,
        });
      }
    });
    this.ActionsSabitGet(2).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        this.FormDataType.Calismadurumu.ComboDataArray.push({
          Id: res.Data[i].Id,
          Value: res.Data[i].Value,
        });
      }
    });
    this.ActionsSabitGet(1).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        this.FormDataType.Cinsiyet.ComboDataArray.push({
          Id: res.Data[i].Id,
          Value: res.Data[i].Value,
        });
      }
    });
    this.ActionsSabitGet(3).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        this.FormDataType.Medenidurum.ComboDataArray.push({
          Id: res.Data[i].Id,
          Value: res.Data[i].Value,
        });
      }
    });
  }
}
export default mznmezunlar